import Axios from "axios";
import { Formik } from "formik";
import * as React from "react";
import { useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { CustomError } from "../Models/CustomError";
import { isCustomError } from "../Utils";
interface IProps extends RouteComponentProps {}

export const ForgotPwd: React.FunctionComponent<IProps> = (
    props: IProps
): JSX.Element => {
    const [reqErrors, setReqErrors] = useState<CustomError>();
    const onCancel = () => {
        props.history?.push("/login");
    };
    return (
        <div className="row justify-content-center">
            <div className="col-4">
                <Formik
                    initialValues={{ email: "" }}
                    onSubmit={async (values, { setSubmitting }) => {
                        console.log(values);
                        //do async call
                        try{
                            await Axios.post(process.env.REACT_APP_API_URL + "/api/v1/identity/forgotPwd",{
                                clientURL: window.location.protocol + "//" + window.location.host + "/resetpwd",
                                email:values.email
                            });

                            //redirect to home
                            props.history?.push("/login");
                        } catch(error){
                            if(isCustomError(error)){
                                setReqErrors(error);
                            }
                        }
                        //setsubmitting
                        setSubmitting(false);
                    }}
                    validate={(values) => {
                        const errors = {
                            email: "",
                        };

                        if (!values.email) {
                            errors.email = "Required";
                        } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                values.email
                            )
                        ) {
                            errors.email = "Invalid email address";
                        }

                        if (errors.email !== "") return errors;

                        return {};
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        handleBlur,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Email Address:</label>
                                <input
                                    className="form-control"
                                    type="email"
                                    placeholder="email"
                                    id="email"
                                    name="email"
                                    onChange={handleChange("email")}
                                    onBlur={handleBlur}
                                    value={values.email}
                                />
                                {touched.email && (
                                    <small className="form-text text-muted">
                                        {errors.email}
                                    </small>
                                )}
                            </div>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                Get Reset Link
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={onCancel}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </button>

                            {reqErrors?.errors.map(
                                (error: string) => (
                                    <small className="form-text text-muted">
                                        {error}
                                    </small>
                                )
                            )}
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};
